import React, { useEffect } from "react";
import { useAuthToken } from "../../../hooks/useAuthToken";
import { IconHome, IconLock } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { ROUTE_LANDING } from "../../../const/routes";
import Logout from "../../Logout";
import Login from "../../../pages/Login.tsx";
import { UserRole } from "../../../types/User.ts";
import LoadingPage from "../loading/LoadingPage.tsx";
import Verify from "../../../pages/Verify.tsx";

const LoginRoute = ({
  children,
  role = UserRole.User,
}: {
  children: React.ReactNode;
  role?: UserRole;
}) => {
  const authToken = useAuthToken();
  useEffect(() => {}, [authToken.status]);

  if (authToken.status === "loading") return <LoadingPage />;
  if (authToken.status === "error") return <Login />;
  if (!authToken.isVerified && !authToken.isRole(role)) return <Verify />;
  if (!authToken.isRole(role))
    return (
      <div className="flex flex-col min-h-screen items-center justify-center gap-4">
        <div className="badge badge-error p-4">
          <IconLock />
          NOT AUTHORISED
        </div>
        <Link className="btn" to={ROUTE_LANDING}>
          <IconHome />
          Zurück zum Start
        </Link>
        <Logout />
      </div>
    );
  return children;
};

export default LoginRoute;
